import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import Store from "store";

import './plugins/iview.js'
router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && !Store.get("token")){
    next('login');
  }

  next();
 })
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
